export default function DrillTopicGridWrapper({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}): React.ReactElement {
  return <div className={`relative isolate filter drop-shadow-xl ${className}`}>{children}</div>
}
